export default __webpack_public_path__ + "static/media/rhrLogo.4b79c613.svg";